var mobileOpen = document.getElementById("mobileOpen");
var mobileClose = document.getElementById("mobileClose");
var page = document.body;
var menuTarget = document.getElementById("mobileMenu");
mobileOpen.addEventListener('click', function(event) {
	page.classList.toggle('mobileOverlay');
	menuTarget.classList.toggle('mobileShowing');
});
mobileClose.addEventListener('click', function(event) {
	page.classList.toggle('mobileOverlay');
	menuTarget.classList.toggle('mobileShowing');
});	
	

var pageGallery = GLightbox();


/* FRONT PAGE SLIDESHOW
const galleryGlide = new Glide('#gallerySlider',{
	type: 'carousel',
	perView: 1,
	perSwipe: '|',
	autoplay: 3000,
	hoverpause: true, 
	dragThreshold: 60
	
}).mount()
*/

// RANDOM NUMBER 
/* function getRandomReview(min, max) {
	return Math.random() * (max - min) + min;
} */